"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCaption = exports.StyledContentLabel = exports.StyledElement = exports.StyledSelectorCardLabel = exports.StyledSelectorCardMessage = exports.StyledSelectorCardDescription = exports.StyledSelectorCardContent = exports.StyledSelectorInputWrapper = exports.StyledTooltip = exports.StyledFooter = exports.StyledContent = exports.StyledBox = void 0;
const theme_1 = require("@pulse-web-ui/theme");
const tooltip_1 = require("@pulse-web-ui/tooltip");
exports.StyledBox = theme_1.styled.div `
  width: ${({ mobileFullWidth }) => (mobileFullWidth ? '100%' : '281px')};

  ${theme_1.media.desktop} {
    width: 100%;
  }
`;
exports.StyledContent = theme_1.styled.div `
  padding-top: 12px;
`;
exports.StyledFooter = theme_1.styled.div `
  padding-top: 12px;
  ${theme_1.typography.medium16}
  line-height: 24px;
  color: ${({ theme }) => theme.colors.text.primary};
`;
exports.StyledTooltip = (0, theme_1.styled)(tooltip_1.Tooltip) `
  position: absolute;
  top: 8px;
  right: 8px;
`;
exports.StyledSelectorInputWrapper = theme_1.styled.div `
  ${theme_1.mixins.flex({
    horizontalAlignment: 'center',
    verticalAlignment: 'center',
})};
  position: absolute;
  top: 16px;
  left: 16px;
  width: 24px;
  height: 24px;
  pointer-events: none;
`;
exports.StyledSelectorCardContent = theme_1.styled.div `
  width: 100%;
  height: 100%;
  border: ${({ theme }) => `2px solid ${theme.colors.neutral[30]}`};
  border-radius: ${({ theme }) => { var _a; return (_a = theme.common.radius12) !== null && _a !== void 0 ? _a : `calc(${theme.common.radius} * 2)`; }};
  box-sizing: border-box;
  padding: 16px 16px 16px 52px;
  cursor: ${({ disabled, readOnly }) => disabled || readOnly ? 'default' : 'pointer'};
  position: relative;
  user-select: none;

  ${({ readOnly, error, theme }) => !readOnly &&
    !error &&
    (0, theme_1.css) `
      &:hover {
        border-color: ${theme.colors.neutral[50]};
      }
    `}

  ${({ error, disabled, readOnly, theme }) => error &&
    !disabled &&
    !readOnly &&
    (0, theme_1.css) `
      border: 2px solid ${theme.colors.accent.error.normal};
      padding: 15px 15px 15px 51px;
    `}
`;
exports.StyledSelectorCardDescription = theme_1.styled.span `
  ${theme_1.typography.regular14};
  line-height: 20px;
  display: block;
  padding-top: 4px;
  color: ${({ theme }) => theme.colors.text.secondary};
`;
exports.StyledSelectorCardMessage = theme_1.styled.span `
  ${theme_1.typography.regular14};
  display: block;
  padding-top: 12px;
  color: ${({ theme }) => theme.colors.neutral[100]};
`;
exports.StyledSelectorCardLabel = theme_1.styled.div `
  ${theme_1.typography.medium16};
  line-height: 24px;
  display: block;
  color: ${({ disabled, theme }) => disabled ? theme.colors.text.secondary : theme.colors.text.primary};

  width: 100%;
`;
exports.StyledElement = theme_1.styled.div `
  padding-top: 12px;
`;
exports.StyledContentLabel = theme_1.styled.div `
  ${theme_1.typography.regular14}
  line-height: 20px;
`;
exports.StyledCaption = theme_1.styled.div `
  ${theme_1.typography.regular12};
  line-height: 18px;
  color: ${({ theme }) => theme.colors.text.warning};
  margin-top: 8px;
`;
